module.exports = __webpack_public_path__ + "img/record.353a6f38.png";